
import BaseCheckbox from "@/components/base/BaseCheckbox.vue";
import { resourceCode } from "@/config/global.strings";
import { DirectionEnum } from "@/models/enums";
import { Extra } from "@/models/www/Extra";
import { ResourceState } from "@/models/www/store/BookingState";
import { useBookingStore } from "@/store/booking";
import { computed, defineComponent, PropType } from "vue";

export default defineComponent({
	components: {
		BaseCheckbox,
	},
	props: {
		extra: {
			type: Object as PropType<Extra>,
			required: true,
		},
		direction: {
			type: Number as PropType<DirectionEnum>,
			required: true,
		},
	},	
	setup(props) {
		
		const bookingStore = useBookingStore();

		const inputValue = computed({
			get(): boolean {
				if (props.extra.resourceCode==="BUS") {
					const resources = bookingStore
										.getAllResources()
										.filter((x) => x.code === props.extra.resourceCode && 
														x.route === props.extra.route).length > 0;	
					return resources;
				}
				else {
					const resources = bookingStore
										.getAllResources()
										.filter((x) => x.code === props.extra.resourceCode).length > 0;	
					return resources;
				}
			},
			set(value: boolean) {
				const amount = value === true ? 1 : 0;
				
				bookingStore.setResource(props.direction, amount, {
					identifier: props.extra.identifier,
					code: props.extra.resourceCode,
					route: props.extra.route,
				} as ResourceState);
				
			},
		});

		return { inputValue, resourceCode };
	},
});
